import React from "react";
import PropTypes from "prop-types";

import Select from "react-select";

class SelectInput extends React.Component {
  ref = React.createRef();
  transformOptions = (
    options,
    selectedOptions = [],
    groupSelectable = true
  ) => {
    const option = (
      value,
      label,
      render,
      disabled = false,
      isParent = false
    ) => ({
      value,
      label,
      render,
      disabled,
      isParent
    });

    return options.reduce((acc, o) => {
      const parent = option(
        o.value,
        this.props.groupFormatter(o.label),
        <span className="option-parent">
          {this.props.groupFormatter(o.label)}
        </span>,
        !groupSelectable,
        true
      );
      let children = [];

      if (
        !!o.children &&
        selectedOptions.findIndex(soption => soption === o.value) < 0
      ) {
        children = o.children.map(c =>
          option(
            c.value,
            c.label,
            <span className="option-child">{c.label}</span>,
            false
          )
        );
      }

      return acc.concat(parent).concat(children);
    }, []);
  };

  handleChange = options => {
    if (Array.isArray(options)) {
      this.props.onChange(options.map(option => option.value));
    } else {
      this.props.onChange(!!options ? options.value : null);
    }
  };

  render() {
    const {
      options,
      placeholder = "",
      selectedOptions = [],
      className,
      groupSelectable,
      multi,
      onClear
    } = this.props;

    const flatOptions = this.transformOptions(
      options,
      selectedOptions,
      groupSelectable
    );

    const selected = flatOptions.filter(option =>
      selectedOptions.includes(option.value)
    );

    return (
      <Select
        placeholder={placeholder}
        isMulti={multi}
        ref={this.ref}
        isClearable={!!onClear}
        isOptionDisabled={option => option.disabled}
        getOptionLabel={option => option.label}
        getOptionValue={option => option.value}
        formatOptionLabel={option => (
          <div className={option.isParent ? "select-headline" : "select-item"}>
            {option.label}
          </div>
        )}
        value={selected}
        onChange={this.handleChange}
        closeMenuOnSelect={true}
        options={flatOptions}
        noOptionsMessage={() => "Keine Ergebnisse"}
        _className={className}
      />
    );
  }
}

SelectInput.propTypes = {
  placeholder: PropTypes.string,
  multi: PropTypes.bool,
  options: PropTypes.array,
  selectedOptions: PropTypes.array,
  onChange: PropTypes.func,
  className: PropTypes.string,
  groupFormatter: PropTypes.func,
  groupSelectable: PropTypes.bool
};

SelectInput.defaultProps = {
  groupSelectable: true,
  multi: true,
  groupFormatter: f => f
};

export default SelectInput;



/** WEBPACK FOOTER **
 ** ./src/components/SelectInput/SelectInput.jsx
 **/